import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://edsytech.com';
const DEFAULT_IMAGE = `${SITE_URL}/images/website.png`;

const SEO = ({
  title,
  description,
  canonicalPath = '/',
  image = DEFAULT_IMAGE,
  keywords = 'EDSY Tech, enterprise SaaS, .NET architecture, Azure cloud, AWS cloud, DevOps, board-ready documentation, enterprise reliability',
  type = 'website',
  jsonLd = null,
}) => {
  const canonicalUrl = `${SITE_URL}${canonicalPath}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="EDSY Tech" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
